import { CLUSTER_CONFIG } from "./cluster_constants";

const getClusterRenderer = (clusterColor = 'rgba(0, 0, 0, 1)', textColor = 'white') => {
    const THRESHOLDS = CLUSTER_CONFIG.THRESHOLDS;
    const ICON_SIZES = CLUSTER_CONFIG.ICON_SIZES;
    const FONT_SIZES = CLUSTER_CONFIG.FONT_SIZES;

    return {
        render({ count, position }) {
            if (typeof window === 'undefined' || !window.google?.maps) {
                return null;
            }
            const size = (count < THRESHOLDS.SMALL) ? ICON_SIZES.SMALL : 
                (count < THRESHOLDS.MEDIUM) ? ICON_SIZES.MEDIUM : 
                (count < THRESHOLDS.LARGE) ? ICON_SIZES.LARGE : ICON_SIZES.XLARGE;
            const fontSize =  (count < THRESHOLDS.SMALL) ? FONT_SIZES.XLARGE : 
                (count < THRESHOLDS.MEDIUM) ? FONT_SIZES.LARGE : 
                (count < THRESHOLDS.LARGE) ? FONT_SIZES.MEDIUM : FONT_SIZES.SMALL;
            const svg = `
                <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 50 50">
                    <defs>
                        <radialGradient id="circleGradient" cx="50%" cy="50%" r="50%">
                            <stop offset="0%" stop-color="${clusterColor}" stop-opacity="0.9"></stop>
                            <stop offset="70%" stop-color="${clusterColor}" stop-opacity="0.6"></stop>
                            <stop offset="100%" stop-color="${clusterColor}" stop-opacity="0.3"></stop>
                        </radialGradient>
                    </defs>

                    <circle cx="25" cy="25" r="22" fill="url(#circleGradient)"></circle>

                    <text x="25" y="28" text-anchor="middle" fill="${textColor}" font-size="${fontSize}" font-weight="bold" font-family="Arial, sans-serif">
                        ${count}
                    </text>
                </svg>
            `;

            return new window.google.maps.Marker({
                position,
                icon: {
                    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
                    scaledSize: new window.google.maps.Size(size, size),
                }
            });
        }
    }
}

export default getClusterRenderer;